import { render, staticRenderFns } from "./PersonalTraining.vue?vue&type=template&id=528e8b96"
import script from "./PersonalTraining.vue?vue&type=script&lang=js"
export * from "./PersonalTraining.vue?vue&type=script&lang=js"
import style0 from "./PersonalTraining.vue?vue&type=style&index=0&id=528e8b96&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports